import { render } from "./MCode.vue?vue&type=template&id=39da8363&scoped=true"
import script from "./MCode.vue?vue&type=script&lang=js"
export * from "./MCode.vue?vue&type=script&lang=js"

import "./MCode.vue?vue&type=style&index=0&id=39da8363&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39da8363"]])

export default __exports__